import { render, staticRenderFns } from "./StockChangeHistory.vue?vue&type=template&id=27a5038b&"
import script from "./StockChangeHistory.vue?vue&type=script&lang=ts&"
export * from "./StockChangeHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports